import { z } from "zod";

import { PollingIntervalGroups } from "apollo/constants";

export const flags = {
  bananaMode: false,
  "billing-usage": false,
  "diff-view-for-json-encoded-values": false,
  "fe-marketing-banners": [],
  "frontend-polling-seconds": {},
  "enable-api-key-creation-for-non-root-admins-frontend": false,
  "use-new-topological-sort-in-runs-view": false,
  "number-of-deployments-widget-frontend": false,
  "approval-policy-evaluations-widget-frontend": false,
  "run-changes-diff-improvements": false,
  "run-summarization-ai": false,
  "stack-list-tag-column": false,
  "logs-virtualization": false,
  "vcs-improvements": false,
  "enable-sparse-checkout": false,
  "bitbucket-api-token-support": false,
  "sharing-modules-between-spaces": false,
  "worker-pool-drift-run-limit": false,
  "squirrel-intent-project": false,
  "org-settings-for-space-admins": false,
  "strip-ansi-codes-from-logs": false,
  "intent-to-iac": false,
  "non-root-admin-role-bindings": false,
  "use-integrations-counts": false,
  "ai-chat": false,
  "enable-self-service-v2": false,
  "terragrunt-manage-state": false,
  "terragrunt-stack-migration": false,
  "intent-new-layout": false,
  "terragrunt-stack-workspaces": false,
  "spacelift-vcs-ui": false,
  "oidc-subject-template-frontend": false,
};

export const selfHostedFlags = {
  "org-settings-for-space-admins": false,
  "non-root-admin-role-bindings": false,
  "enable-self-service-v2": false,
};
export const FEMarketingBanner = z.object({
  id: z.string(),
  expirationDate: z.string().optional(),
});

export type FEMarketingBanner = z.infer<typeof FEMarketingBanner>;

type JsonTypes = {
  "fe-marketing-banners": FEMarketingBanner[];
  "frontend-polling-seconds": {
    group?: Record<PollingIntervalGroups, number>;
    singleQuery?: Record<string, number>; // string is the Operation name
  };
};

type KebabToCamelCase<S extends string> = S extends `${infer P1}-${infer P2}${infer P3}`
  ? `${P1}${Uppercase<P2>}${KebabToCamelCase<P3>}`
  : S;

type ObjectKeysFromKebabToCamelCase<ObjectType> = {
  [K in keyof ObjectType as K extends string ? KebabToCamelCase<K> : K]: ObjectType[K];
};

type FlagsWithJsonValues = Omit<typeof flags, keyof JsonTypes> & JsonTypes;

export type Flags = ObjectKeysFromKebabToCamelCase<FlagsWithJsonValues>;
export type SefHostedFlags = ObjectKeysFromKebabToCamelCase<typeof selfHostedFlags>;
